// Shared moment.js display format patterns, to avoid re-declaring a local `DATE_FORMAT`
// constant in every component that renders a date.

/** e.g. "23 July 2026" */
export const DATE_FORMAT_FULL = 'DD MMMM YYYY';

/** e.g. "Thursday 23 July 2026" */
export const DATE_FORMAT_FULL_WEEKDAY = 'dddd DD MMMM YYYY';

/** e.g. "Wed 23 Jul, 2:00 PM" */
export const DATE_FORMAT_WEEKDAY_TIME = 'ddd DD MMM, LT';
